import React from "react";
import useTranslation from '../hooks/useTranslation';

// Shared Dashboard UI components to eliminate duplicate rendering patterns

export function EmptyState({ message }) {
  return (
    <div style={{ textAlign: "center", marginTop: 60, fontSize: 20, color: "#999" }}>
      {message}
    </div>
  );
}

export function MoodBalanceBar({ title, posPct }) {
  const { t } = useTranslation();
  return (
    <div className="dash-emotions-box" style={{ padding: 12 }}>
      <div className="dash-emotions-title">{title}</div>
      <div style={{ marginTop: 12 }}>
        <div style={{ height: 14, background: '#2b2623', borderRadius: 10, overflow: 'hidden' }}>
          <div style={{
            width: `${posPct}%`,
            height: '100%',
            background: posPct > 60 ? '#4CAF50' : (posPct > 40 ? '#FFC107' : '#E53935'),
            transition: 'width 240ms ease'
          }} />
        </div>
        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#bbb' }}>
          <span>{t('Positive')}</span>
          <span>{posPct.toFixed(1)}%</span>
        </div>
      </div>
    </div>
  );
}

export function DominantEmotionSummary({ period, dominant, stressDelta, EMOJI }) {
  const { t } = useTranslation();
  const sameLabel = t(`Stress was about the same as last ${period}.`);
  const droppedLabel = t(`Stress dropped compared to last ${period}.`);
  const increasedLabel = t(`Stress increased compared to last ${period}.`);
  
  return (
    <div className="summary-box" style={{ background: '#111', color: '#fff', borderRadius: 16, padding: 16, marginBottom: 14 }}>
      <div style={{ fontSize: 18, fontWeight: 700 }}>{t(`This ${period}`)}</div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
        <span style={{ fontSize: 34, marginRight: 10 }}>{EMOJI[dominant.raw] || '🙂'}</span>
        <div style={{ fontSize: 16 }}>
          <div style={{ fontWeight: 600 }}>{t('Mostly')} {dominant.name}</div>
          {stressDelta != null && (
            <div style={{ opacity: 0.9 }}>
              {Math.abs(stressDelta) < 0.5 ? sameLabel : (
                stressDelta < 0 ? droppedLabel : increasedLabel
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
